import React, { Component } from "react";
import { Sticky, Transition } from "semantic-ui-react";
import menuBtnImage from "../../semantic/dist/themes/fibrestream/assets/images/hamburger.svg";
import Message from './message/Message';

class WhiteHeader extends Component {
  constructor(props) {
    super(props);
    this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

    this.state = {
      headerBg: false,
      windowWidth: null,
      isMessageVisible: true
    };
    this.getWidth = this.getWidth.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  componentDidMount() {
    if (this.isChrome) {
      this.setState({
        windowWidth: window.innerWidth
      });
    }
    else {
      this.setState({
        windowWidth: document.documentElement.clientWidth
      });
    }

    window.addEventListener('resize', this.getWidth, false);
  }

  getWidth() {
    if (this.isChrome) {
      this.setState({
        windowWidth: window.innerWidth
      });
    }
    else {
      this.setState({
        windowWidth: document.documentElement.clientWidth
      });
    }
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.getWidth, false);
  }
  onClose() {
    this.setState({
      isMessageVisible: false
    })
    setTimeout(() => {
      this.props.measureHeight();
    })
  }

  render() {
    const { windowWidth, isMessageVisible } = this.state;

    return <div className={'ui vertical segment py-0 border-0' + ((this.props.inverted) ? ' black' : ' default')}>
      {isMessageVisible && <Message onClose={this.onClose} />}
      <Sticky context={this.props.stickyContext} className="sticky-header-container">
        <div className="sticky-nav">
          <div className="ui grid mobile only menu--xs">
            <div className="hamburger cursor-pointer" onClick={this.props.toggleMobileMenu} ref={this.props.toggleContainer}>
              <img
                src={menuBtnImage}
                alt="Navigation"
                width="52"
                height="32"
              />
            </div>
          </div>
          <div className={this.props.mobileMenuSwitch ? 'nav xs-block' : 'nav'}>
            <div className="ui container">
              {windowWidth >= 768 &&
                <div className="ui grid row centered middle aligned">
                  <div className="three wide computer four wide tablet column pr-0">
                    {this.props.getLogo()}
                  </div>
                  <div className="eleven wide computer ten wide tablet column pr-0 py-0">
                    {this.props.getMenu()}
                  </div>
                  <div className="two wide column py-0">
                    <div className="ui text menu">
                      {this.props.getSignupMenu()}
                    </div>
                  </div>
                </div>
              }
              {windowWidth <= 767 &&
                <div>
                  {this.props.getLogo()}
                  <Transition mountOnShow={false} visible={this.props.mobileMenuSwitch} animation="slide down" duration={500}>
                    {this.props.getMenu()}
                  </Transition>
                  {this.props.getSignupMenu()}
                </div>
              }
            </div>
          </div>
        </div>
      </Sticky>
    </div>
  };
}


export default WhiteHeader;


// WEBPACK FOOTER //
// ./src/components/header/WhiteHeader.js